<template>

    <section id="aboutsection">
    
        <article id="about">
                <div class="container-fluid about">
                    <h1 class="section-header">{{ main.headings.about}}</h1>

                    <div class="row">

                        <div
                            class="col-sm-12 col-md-6 flex-col cv-img"
                            data-aos="fade-up"
                            data-aos-duration="1000"   
                            data-aos-anchor-placement="bottom-bottom"
                        >
                            <a href="/cv.pdf" class="download-cv-zg" download="ZuzanaGabonayovaCV.pdf">
                                <img src="../assets/images/about/cv.png" alt="cv" class="cv">
                            </a>

                        </div>


                        <div
                            class="col-sm-12 col-md-6 flex-col about-bio"
                            data-aos="fade-left"
                            data-aos-duration="1000"
                            data-aos-anchor-placement="bottom-bottom"
                            style="margin: 0 auto;"
                        >
                            <p>
                                
                                <span id="bio">
                                {{ bio1 }}
                                <br>
                                <br>
                                {{ bio2 }}
                                
                                </span>
                            </p>

                            <div class="buttons-container">

                            <button class="contact" onclick="location.href = '#contact';">
                                CONTACT ME
                            </button>

                            <a href="/cv.pdf" class="download-cv-zg" download="ZuzanaGabonayovaCV.pdf">
                                <button class="download" download>
                                DOWNLOAD CV
                                </button>
                            </a>

                            </div>

                        </div>

                    </div>
                </div>
        </article>

    </section>

</template>

<script>

import data from "../data/data.json";

export default {
    name: "AboutView",
    data: () => {
        return {
            main: data.main,
            bio1: data.about.bio1,
            bio2: data.about.bio2
        };
    },
}
</script>